import { CharterCabinClass, CharterFlight, SeatSelectionState, Traveller } from '../charter.types';

export const UNKNOWN_CABIN_CLASS_MESSAGE = 'Cabin class could not be determined for this traveller and flight.';

export const CABIN_CLASS_LABELS: Record<CharterCabinClass, string> = {
  business: 'Business',
  lux_row: 'SkyLounge',
  lux_row_pax_one: 'SkyLounge for One',
  premium_economy: 'Premium Economy',
  economy: 'Economy',
};

export function formatCabinClass(cabinClass: CharterCabinClass | null | undefined): string {
  return cabinClass ? CABIN_CLASS_LABELS[cabinClass] : 'Unknown';
}

export function getTravellerCabinClass(traveller: Traveller, flightId: string): CharterCabinClass | null {
  return traveller.flightAssignments?.[flightId]?.cabinClass ?? null;
}

export function buildSeatSelectionsFromFlightAssignments(
  travellers: Array<Traveller>,
  flights: Array<Pick<CharterFlight, 'id'>>,
): SeatSelectionState {
  return flights.reduce<SeatSelectionState>((acc, flight) => {
    acc[flight.id] = travellers.reduce<Record<string, string | null>>((byTraveller, traveller) => {
      byTraveller[traveller.id] = traveller.flightAssignments?.[flight.id]?.seat ?? null;
      return byTraveller;
    }, {});

    return acc;
  }, {});
}

export function getUsedCabinClassesForFlight(
  flight: CharterFlight,
  travellers: Array<Traveller>,
): Array<CharterCabinClass> {
  const usedCabins = new Set(
    travellers
      .map((traveller) => getTravellerCabinClass(traveller, flight.id))
      .filter((cabinClass): cabinClass is CharterCabinClass => Boolean(cabinClass)),
  );

  if (usedCabins.size === 0) {
    return [flight.baseCabinClass];
  }

  const cabinLayoutOrder = Array.from(new Set(flight.cabinLayout.map((row) => row.cabin)));
  return Array.from(usedCabins).sort((a, b) => cabinLayoutOrder.indexOf(a) - cabinLayoutOrder.indexOf(b));
}
